import { useTranslation } from 'react-i18next';
import '../../styles/Projects.css';
import Header from '../../components/layout/Header';
import divina from '../../assets/img/divina.webp';
import farolseo from '../../assets/img/farolseo.webp';
import gallery from '../../assets/img/gallery.webp';
import wordpress from '../../assets/img/muller.webp';
import cyber from '../../assets/img/cyber.webp';
import HausHeld from '../../assets/img/vermando.webp';
import { trackMatomoEvent } from '../../utils/matomo';

const ProjectsSection = () => {
  const { t } = useTranslation();

  return (
    <main>
      <Header />
      <section className="projects-section">
        <div className="projects-header">
          <h2>{t('projects.title')}</h2>
          <p>{t('projects.subtitle')}</p>
        </div>

        <div className="projects-grid">
          <div className="project-card">
            <div className="project-image">
              <img
                src={divina}
                alt={t('projects.items.0.title')}
                fetchPriority="high"
                decoding="sync"
                loading="eager"
              />
              <span className="project-category">
                {t('projects.items.0.category')}
              </span>
            </div>
            <div className="project-info">
              <h3>{t('projects.items.0.title')}</h3>
              <p>{t('projects.items.0.description')}</p>
              <a
                href="https://www.divina.ch/de"
                onClick={() =>
                  trackMatomoEvent('Outbound', 'click', 'Project Divina')
                }
              >
                {t('projects.view_details')}
              </a>
            </div>
          </div>

          <div className="project-card">
            <div className="project-image">
              <img
                src={farolseo}
                alt={t('projects.items.1.title')}
                fetchPriority="high"
                decoding="sync"
                loading="eager"
              />
              <span className="project-category">
                {t('projects.items.1.category')}
              </span>
            </div>
            <div className="project-info">
              <h3>{t('projects.items.1.title')}</h3>
              <p>{t('projects.items.1.description')}</p>
              <a
                href="https://farol-seo.com/"
                onClick={() =>
                  trackMatomoEvent('Outbound', 'click', 'Project Farol SEO')
                }
              >
                {t('projects.view_details')}
              </a>
            </div>
          </div>

          <div className="project-card">
            <div className="project-image">
              <img
                src={gallery}
                alt={t('projects.items.2.title')}
                fetchPriority="high"
                decoding="sync"
                loading="eager"
              />
              <span className="project-category">
                {t('projects.items.2.category')}
              </span>
            </div>
            <div className="project-info">
              <h3>{t('projects.items.2.title')}</h3>
              <p>{t('projects.items.2.description')}</p>
              <a
                href="https://www.galeriegleis4.com/en/gallery-gleis4/"
                onClick={() =>
                  trackMatomoEvent(
                    'Outbound',
                    'click',
                    'Project Gallery Gleis 4',
                  )
                }
              >
                {t('projects.view_details')}
              </a>
            </div>
          </div>

          <div className="project-card">
            <div className="project-image">
              <img
                src={wordpress}
                alt={t('projects.items.3.title')}
                fetchPriority="high"
                decoding="sync"
                loading="eager"
              />
              <span className="project-category">
                {t('projects.items.3.category')}
              </span>
            </div>
            <div className="project-info">
              <h3>{t('projects.items.3.title')}</h3>
              <p>{t('projects.items.3.description')}</p>
              <a
                href="https://mueller-handarbeiten.ch/"
                onClick={() =>
                  trackMatomoEvent('Outbound', 'click', 'Project Mueller')
                }
              >
                {t('projects.view_details')}
              </a>
            </div>
          </div>

          <div className="project-card">
            <div className="project-image">
              <img
                src={cyber}
                alt={t('projects.items.4.title')}
                fetchPriority="high"
                decoding="sync"
                loading="eager"
              />
              <span className="project-category">
                {t('projects.items.4.category')}
              </span>
            </div>
            <div className="project-info">
              <h3>{t('projects.items.4.title')}</h3>
              <p>{t('projects.items.4.description')}</p>
              <a
                href="https://www.sport1001.ch/"
                onClick={() =>
                  trackMatomoEvent('Outbound', 'click', 'Project Sport 1001')
                }
              >
                {t('projects.view_details')}
              </a>
            </div>
          </div>

          <div className="project-card">
            <div className="project-image">
              <img
                src={HausHeld}
                alt={t('projects.items.5.title')}
                fetchPriority="high"
                decoding="sync"
                loading="eager"
              />
              <span className="project-category">
                {t('projects.items.5.category')}
              </span>
            </div>
            <div className="project-info">
              <h3>{t('projects.items.5.title')}</h3>
              <p>{t('projects.items.5.description')}</p>
              <a
                href="https://www.HausHeld.ch/"
                onClick={() =>
                  trackMatomoEvent('Outbound', 'click', 'Project HausHeld')
                }
              >
                {t('projects.view_details')}
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ProjectsSection;
